import { canUseWindow } from '@library/environment'

/**
 * @description Decide if call should be tracked as part of Spice project Menu experience calls
 *
 * Can be removed if project Spice is completed
 *
 * Metrics are visible here https://eu-west-1.console.aws.amazon.com/cloudwatch/home?region=eu-west-1#dashboards/dashboard/Turnips-Spice-Dashboard?start=PT12H&end=null
 */
export const isMenuApiCall = () => {
  if (!canUseWindow()) {
    return false // Server side calls are not tracked
  }

  return typeof window !== 'undefined' && window.location?.pathname?.match(/\/menu\/?$/)
}
